export default {
  API_ENDPOINT: 'https://castelanismos-non-api.herokuapp.com',
  TOKEN_KEY: 'blogful-client-auth-token',
}
